import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { resetFilter } from 'redux/actions/newFilter';
import {
  getListEmployee,
  setEmployeeStatus,
} from '../../redux/actions/employee';

import EmployeeListPage from './EmployeeList.page';

const mapStateToProps = state => ({
  listEmployee: state.organization.employeeList,
  employeeId: state.organization.employeeId,
  getLoading: state.organization.getLoading,
  viewAll: state.auth.modulesViewAll,
  me: state.auth.me,
  filterValue: state.newFilter.filterValue,
  formControlShow: state.newFilter.formControlShow,
  employeeFilter: state.organization.employeeFilter,
});

const mapDispatchToProps = { getListEmployee, setEmployeeStatus, resetFilter };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EmployeeListPage));
